import Vue from 'vue'
import Vuex from 'vuex'

import app from './app'
import time from './time'
import user from './user'
import tireReports from './tirereports'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    app,
    time,
    user,
    tireReports
  },
  strict: false,
  plugins: [],
})

export const initializeStores = function () {
  // Initialize stores
}


